import { Button, cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import { useDeps } from '@Contexts/DI';
import Link from '@Navigation/Link';
import styles from './Text.module.css';

import type { FC, HTMLAttributes } from 'react';

interface TextProps extends HTMLAttributes<HTMLDivElement> {
  onClick?(): void;
}

const Text: FC<TextProps> = (props) => {
  const { className, onClick, ...restProps } = props;
  const { t } = useTranslation();
  const { analytics } = useDeps();
  const description = t('description');
  const button = t('assemble-the-kit');

  const handleClick = () => {
    if (!onClick) return;

    analytics.dispatchEvent('landing.interact', {
      label: 'Собрать комплект',
      category: 'Section',
      action: 'scroll',
    });

    onClick();
  };

  return (
    <div className={cn(styles.container, className)} {...restProps}>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html: description }} />
      <Link className={styles.link} onClick={handleClick}>
        <Button className={styles.button} theme='secondary'>
          {button}
        </Button>
      </Link>
    </div>
  );
};

export default Text;
